import { defineRecipe } from "@chakra-ui/react-v3";

/**
 * Tiger's text input: what v2's `Input` renders with its default `outline`
 * variant and `md` size, the only ones v3 consumers use so far. Add a variant
 * here when a consumer needs another.
 *
 * The order of the states matters, as in v2: focus comes after invalid, so a
 * focused invalid input shows the focus ring rather than the red border.
 */
export const inputRecipe = defineRecipe({
  base: {
    // `InputGroup` pads the input by this much to make room for an element.
    "--input-height": "sizes.9",

    width: "100%",
    minWidth: "0",
    height: "var(--input-height)",
    px: "2",
    // v2 turns `outline: 0` into this, so high-contrast mode, which drops box
    // shadows, still draws an outline.
    outline: "2px solid transparent",
    outlineOffset: "2px",
    position: "relative",
    appearance: "none",
    textAlign: "start",

    // v2's `base` text style.
    fontSize: "sm",
    fontWeight: "medium",
    letterSpacing: "tighter",
    // v2 used 1.43, which a single-line input of fixed height doesn't show.
    lineHeight: "body",

    bg: "inherit",
    border: "1px solid",
    borderColor: "neutral.emphasized",
    borderRadius: "lg",

    _placeholder: {
      opacity: 1,
      color: "fg.subtle",
    },
    _hover: {
      borderColor: "highlight.solid",
    },
    _readOnly: {
      boxShadow: "none !important",
      userSelect: "all",
    },
    _invalid: {
      borderColor: "error.solid",
      boxShadow: "none",
    },
    _focus: {
      zIndex: 1,
      borderColor: "highlight.solid",
      boxShadow: "0 0 0 4px {colors.highlight.muted}",
    },
    _disabled: {
      borderColor: "neutral.emphasized",
      color: "fg.subtle",
      cursor: "default",
      // `_hover` excludes disabled inputs, so this selector is spelled out.
      "&:hover": {
        borderColor: "neutral.solid",
      },
    },
  },
});
